export interface OtherProps {}

const Other: React.FC<OtherProps> = () => {
  return null;
};

export default Other;
